import { ReactElement, ReactNode, cloneElement, isValidElement } from "react"
import clsx from "clsx"
import usePathname from "@/hooks/usePathname"
import { Link } from "@inertiajs/react"

const NavMenuButton = ({
  href,
  onClick,
  name,
  icon,
  badge,
}: {
  href?: string
  onClick?: () => void
  name: string
  icon: ReactNode
  badge?: string
}) => {
  const pathname = usePathname()
  const current = href && pathname.startsWith(href)

  icon = isValidElement(icon)
    ? cloneElement(icon as ReactElement<any>, {
        className: clsx(
          current ? "text-gray-900" : "text-gray-500 group-hover:text-gray-900",
          "h-6 w-6 shrink-0"
        ),
        "aria-hidden": true,
      })
    : null

  const classes = clsx(
    current
      ? "bg-gray-100 text-gray-900"
      : "text-gray-500 hover:bg-gray-100 hover:text-gray-900",
    "group flex w-full items-center gap-x-2.5 rounded-lg px-3.5 py-3 text-base leading-4 font-semibold"
  )

  if (href) {
    return (
      <Link className={classes} href={href}>
        {icon}
        <span>{name}</span>
        {badge ? (
          <span className="rounded-full bg-chessdrop-600 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white">
            {badge}
          </span>
        ) : null}
      </Link>
    )
  }

  if (onClick) {
    return (
      <button className={classes} onClick={onClick}>
        {icon}
        <span>{name}</span>
        {badge ? (
          <span className="rounded-full bg-chessdrop-600 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white">
            {badge}
          </span>
        ) : null}
      </button>
    )
  }

  return null
}

export default NavMenuButton
